import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const GROUP_RESTORE_RESOURCE = "group" as const;
export const GROUP_RESTORE_API_PATH = `/v1/${GROUP_RESTORE_RESOURCE}/{uuid}/restore` as const;

export type GroupRestoreResponse =
  paths[typeof GROUP_RESTORE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useGroupRestoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<GroupRestoreResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<GroupRestoreResponse>(
        `/v1/${GROUP_RESTORE_RESOURCE}/${uuid}/restore`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GROUP_RESTORE_RESOURCE],
      });
    },
  });
};
